import { z } from "zod";
import { zId, zInstanteUtc } from "./dominio.js";
/**
 * O que a importação troca pela rede. O relatório em si é montado pelo
 * validador puro (`importar.ts`); aqui está a forma que ele tem no contrato.
 */
export const zProblema = z.object({
    onde: z.string(),
    mensagem: z.string(),
    /** Nunca vazio: um erro sem saída só informa que a noite acabou. */
    comoResolver: z.string().min(1),
});
export const zRelatorio = z.object({
    ok: z.boolean(),
    erros: z.array(zProblema),
    avisos: z.array(zProblema),
    totalItens: z.number().int(),
    faixaIds: z.object({ inicio: z.number().int(), fim: z.number().int() }).nullable(),
    categoriasNovas: z.array(z.array(z.string())),
    colisao: z
        .object({
        ids: z.array(z.number().int()),
        deslocamento: z.number().int(),
        faixaLivre: z.object({ inicio: z.number().int(), fim: z.number().int() }),
    })
        .nullable(),
    trilha: z.string().nullable(),
    lote: z.string().nullable(),
});
/**
 * O arquivo viaja como texto, não como upload multipart.
 *
 * É JSON de alguns quilobytes vindo de um único usuário; multipart traria uma
 * dependência e um diretório temporário para gerenciar, e o invariante 9 já
 * obriga a pensar em caminho de disco configurável. Texto no corpo evita os
 * dois — e o arquivo nunca toca o disco do servidor.
 */
export const zImportacaoEntrada = z.object({
    conteudo: z.string().min(1, "Escolha um arquivo"),
});
export const zConfirmarImportacao = zImportacaoEntrada.extend({
    /** Aplica o deslocamento oferecido pelo relatório (RN-22). Explícito de propósito. */
    deslocar: z.boolean().default(false),
});
export const zLote = z.object({
    id: zId,
    nome: z.string(),
    origem: z.string().nullable(),
    importadoEm: zInstanteUtc,
    faixaInicio: z.number().int(),
    faixaFim: z.number().int(),
    totalItens: z.number().int(),
    itensAtuais: z.number().int(),
});
export const zListaDeLotes = z.object({ lotes: z.array(zLote) });
export const zImportacaoFeita = z.object({
    loteId: zId,
    relatorio: zRelatorio,
    lotes: z.array(zLote),
});
export const zLoteId = z.object({ id: zId });
/** Exclusão de lote em bloco exige o nome digitado (RN-23, RN-25). */
export const zLoteExclusao = z.object({ confirmacaoNome: z.string() });
//# sourceMappingURL=importar-contrato.js.map